export enum IconVariant {
  Regular = 'regular',
  Solid = 'solid',
  Light = 'light',
  Thin = 'thin',
  Duotone = 'duotone',
  Brands = 'brands',
}
